import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {HttpSearchRepository} from '../Repositories/HttpSearchRepository.js'
import {GetSearchRequestFromAISearchRequest} from '../Request/GetSearchRequestFromAISearchRequest.js'

// This a temporary use case that will be removed once the new search is fully implemented
// Related tech-debt: https://jira.ets.mpi-internal.com/browse/MTR-94416

class GetRentingSearchRequestFromAISearchUseCase extends UseCase {
  #config
  #repository

  static create({config}) {
    return new GetRentingSearchRequestFromAISearchUseCase({
      config,
      repository: HttpSearchRepository.create({config})
    })
  }

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  @tracer({metric: 'GetRentingSearchRequestFromAISearchUseCase#execute'})
  @AsyncInlineError()
  async execute({query, listingSectionId, url, variant} = {}) {
    try {
      const [error, response] = await this.#repository.getRentingSearchRequestFromAI({
        config: this.#config,
        searchRequest: GetSearchRequestFromAISearchRequest.createFromSearch({
          config: this.#config,
          listingSectionId,
          query
        }),
        url,
        variant
      })

      return error
        ? Promise.reject(
            DomainSharedError.isDomainError({error})
              ? error
              : DomainSharedError.createGenericError({config: this.#config, cause: error})
          )
        : response
    } catch (error) {
      return Promise.reject(DomainSharedError.createGenericError({config: this.#config, cause: error}))
    }
  }
}

export const factory = GetRentingSearchRequestFromAISearchUseCase.create
